<template>
  <div>
    <a class="btn" :href="path" download>
      {{ label }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, default: 'Download' },
    path: { type: String, required: true, },
    height: { type: String, default: 'auto' },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.btn {
  align-self: center;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border-radius: 30px;
  box-shadow: -5px 10px 30px rgba(0, 0, 0, 0.2);
  background-image: linear-gradient(270deg, #97ca54 0%, #83ca54 100%);
  cursor: pointer;
  border: none;
  text-decoration: none;
  display: block;
  padding: 18px 40px;
  text-align: center;

  @include desktop {
    display: none;
  }
}
</style>